import React, {useEffect, useRef} from 'react'
import useTheme from '../hooks/useTheme'

interface Props {
	onChange: React.ChangeEventHandler<HTMLInputElement>
	fileName: string
	errorText?: string | string[]
	isError?: boolean
}

const UploadFile: React.FC<Props> = ({
	onChange,
	fileName,
	isError,
	errorText
}) => {
	const theme = useTheme()
	const fileInputRef = useRef<HTMLInputElement>(null)
	const handleClear = () => {
		if(fileInputRef.current){
			fileInputRef.current.value = ''
		}
	}

	useEffect(() => {
		if(fileName === '') {
			handleClear()
		}
	}, [fileName])

	return (
		<label
			className={`upload ${isError ? 'upload-error' : ''}`}
			htmlFor="inputFile"
		>
			<div className={`upload-button ${theme === 'dark' ? 'dark' : ''}`}>Обрати</div>
			<input
				readOnly={true}
				placeholder='Оберіть файл'
				value={fileName}
				className='upload-input'
			/>
			<input
				ref={fileInputRef}
				accept="image/png, image/jpeg, application/pdf"
				onChange={(event) => {
					onChange(event)
				}}
				id="inputFile"
				type="file"
			/>
			<span className='error-text'>
				{typeof errorText === 'string' ? errorText :
					typeof errorText === 'object' ? errorText[0] : ''
				}
			</span>
		</label>
	)
}

export default UploadFile